import React from 'react'
import {Link} from "react-router-dom"
import {BiError} from "react-icons/bi"

const Error = () => {
  return (
    <>
    
    <div style={{
        display: "flex",
        flexDirection : "column",
        width: "100vw",
        height: "100vh",
        alignItems : "center",
        justifyContent : "center",
    }}>
        <BiError style={{
            fontSize: "100px",
            color:"#6e07f3"
        }}/>
        <h2 style={{
            fontSize: "30px"
        }}>Looks like you're lost</h2>
        <p 
        style={{
            fontSize: "16px"
        }}
        className='caption'>Maybe try a different page?</p>
        <Link to={"/"} style={{
            textDecoration : "none",
            color: "white",
            padding : "10px 20px",
            border: "2px solid #6e07f3",
            marginTop: "15px",
            borderRadius: "100px",
            fontWeight: "500"
        }}>Return Home</Link>
    </div>
    </>
   )
}

export default Error